import { render, staticRenderFns } from "./SignError.vue?vue&type=template&id=6200b8fe&"
import script from "./SignError.vue?vue&type=script&lang=js&"
export * from "./SignError.vue?vue&type=script&lang=js&"
import style0 from "./SignError.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports